<template>
    <div class="hidden lg:block bg-a-brown-ebdac1 mt-16">
        <div class="flex justify-center py-3">
            <div>
                <img class="size-img-mobile" src="../../../assets/download_app/app-screen.png">
            </div>
            <div class="pt-7">
                <div class="text-32 font-bold text-a-brown-502314">Download Application</div>
                <div class="text-20 text-a-brown-502314 mt-4">Burger King Thailand Applications</div>
                <div class="mt-7">
                    <img class="h-9 inline-block mr-4 cursor-pointer" @click="clickDownLoadIOS()" src="../../../assets/download_app/download-ios.png">
                    <img class="h-9 inline-block cursor-pointer" @click="clickDownLoadAndroid()" src="../../../assets/download_app/download-android.png">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        clickDownLoadIOS: function() {
            window.location.href = "https://apps.apple.com/th/app/burger-king-thailand/id1440299482?l=th";
        },
        clickDownLoadAndroid: function() {
            window.location.href = "https://play.google.com/store/apps/details?id=com.bzbs.burgerking";
        }
    }
}
</script>
<style lang="scss" scoped>
    .size-img-mobile {
        height: 300px;
    }
</style>
